import React, { Component, PropTypes } from 'react';
import Drawer from 'Cio/Drawer';
import PageLayoutEditor from 'components/Page/PageLayoutEditor';
import Loader from 'Cio/Loader';

const css = oxygenCss({
  layoutEditor: {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: 390
  },
  moduleEditor: {
    position: 'absolute',
    left: 390,
    bottom: 0,
    width: 390,
    top: 0
  },
  root: {
    overflow: 'hidden'
  }
});

class PageLayoutOverview extends Component {
  static propTypes = {
    layout: PropTypes.object,
    closeLayoutEditor: PropTypes.func,
    openModuleMenu: PropTypes.func,
    loading: PropTypes.bool,
    selectedPageModuleId: PropTypes.number,
    onSelectModule: PropTypes.func
  };

  componentWillReceiveProps(nextProps) {
    const { selectedPageModuleId, onSelectModule } = this.props;
    if (nextProps.selectedPageModuleId !== selectedPageModuleId) {
      onSelectModule && onSelectModule(nextProps.selectedPageModuleId);
    }
  }

  render() {
    const {
      layout,
      openModuleMenu,
      closeLayoutEditor,
      loading,
      ...other
    } = this.props;
    if (loading) {
      return <Loader />;
    }
    return (
      <Drawer
        className={css.root}
        slide={false}
        // closeOnEsc={false}
        onRequestClose={this.unselect}
        {...other}
      >
        <PageLayoutEditor
          closeLayoutEditor={closeLayoutEditor}
          openModuleMenu={openModuleMenu}
          layout={layout}
          {...other}
        />
      </Drawer>
    );
  }
}

export default PageLayoutOverview;



// WEBPACK FOOTER //
// ./src/js/components/Page/PageLayout.js